<div
	class="ml-12 padding-0-5 p-b-0 font-size-12 label-text-light"
	fxLayout="row"
	*ngIf="showDragAndDropText"
>
	Drag and drop carriers to add them to projects. Use Shift + Click to select multiple carriers
</div>
<div class="ml-12 primary-text font-size-17 padding-0-5 p-b-0 pt-2" fxLayout="row">
	<div fxFlex fxLayoutAlign="start center">
		<mat-form-field fxFlex class="remove_form_field_margin">
			<mat-label>Start typing to filter projects</mat-label>
			<input [(ngModel)]="projectSearchText" autocomplete="off" matInput />
		</mat-form-field>
	</div>
	<div fxFlex fxLayoutAlign="end center">
		<app-project-dialog
			(updatedData)="projectAddedOrUpdated($event)"
			[addProject]="true"
			[lanePricing]="lanePricing"
			[searchTruckForm]="searchTruckForm"
			[truckLaneSearchId]="truckLaneSearchId"
			[truckSearchId]="truckSearchId"
			projectSource="capacity_search"
			[usersList]="usersList"
		></app-project-dialog>
	</div>
</div>

<div class="ml-12">
	<app-skeleton-loader
		*ngIf="!truckSearchResult"
		class="full-width h-100"
		[SHOW_PANEL]="true"
		[DEFAULT_ROWS_SIZE]="3"
	>
	</app-skeleton-loader>

	<div *ngIf="truckSearchResult">
		<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(openedMatch)">
			<div
				*ngFor="
					let project of selectedCarriersProjectMap | search: 'projectName' : projectSearchText;
					let i = index
				"
				class="padding-0-5 p-b-0"
			>
				<mat-card
					(drop)="drop($event, project.projectId)"
					[dragOverClass]="'dropHover'"
					[ngClass]="{ 'primary-border': project.isCarrierMappedToProject }"
					class="full-width"
					dragHintClass="no-border"
					droppable
				>
					<mat-card-content
						(click)="navigateToProjectDetails(project.projectId)"
						class="primary-text cursor-pointer"
					>
						<div fxLayout="row" fxLayoutGap="1rem">
							<ng-container
								*ngTemplateOutlet="projectNameTemplate; context: { $implicit: project }"
							></ng-container>
							<div fxFlex fxLayoutAlign="end center">
								Customer: {{ project?.customer ? project.customer : 'N/A' }}
							</div>
						</div>

						<div class="m-t-1" fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="start center">
								volume: {{ project?.monthlyVolumeDisplay ? project.monthlyVolumeDisplay : 'N/A' }}
							</div>
							<div fxFlex fxLayoutAlign="end center">
								Carriers:
								<span
									[matBadge]="project.carrierCount"
									[ngClass]="{ 'custom-badge-w-auto': project.carrierCount >= 100 }"
									class="custom-badge m-r-1-4 pl-2"
									matBadgeOverlap="false"
								></span>
							</div>
						</div>
					</mat-card-content>
				</mat-card>
			</div>

			<div
				*ngFor="
					let project of carrierProjectMap
						| search: 'projectName' : projectSearchText
						| slice: 0 : projectsLimit;
					let i = index
				"
				class="padding-0-5 p-b-0"
			>
				<mat-card
					(drop)="drop($event, project.projectId)"
					*ngIf="
						selectedCarriersProjectIds.indexOf(project.projectId) === -1 &&
						!showOnlySelectedCarriersProject
					"
					[dragOverClass]="'dropHover'"
					[ngClass]="{ 'primary-border': project.isCarrierMappedToProject }"
					class="full-width"
					dragHintClass="no-border"
					droppable
				>
					<mat-card-content
						(click)="navigateToProjectDetails(project.projectId)"
						class="primary-text cursor-pointer"
					>
						<div fxLayout="row" fxLayoutGap="1rem">
							<ng-container
								*ngTemplateOutlet="projectNameTemplate; context: { $implicit: project }"
							></ng-container>
							<div fxFlex fxLayoutAlign="end center">
								Customer: {{ project?.customer ? project.customer : 'N/A' }}
							</div>
						</div>

						<div class="m-t-1" fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="start center">
								volume: {{ project?.monthlyVolumeDisplay ? project.monthlyVolumeDisplay : 'N/A' }}
							</div>
							<div fxFlex fxLayoutAlign="end center">
								Carriers:
								<span
									[matBadge]="project.carrierCount"
									[ngClass]="{ 'custom-badge-w-auto': project.carrierCount >= 100 }"
									class="custom-badge m-r-1-4 pl-2"
									matBadgeOverlap="false"
								></span>
							</div>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</div>

		<div *ngIf="IS_NULL_OR_UNDEFINED(openedMatch) && IS_NOT_NULL_OR_UNDEFINED(projectsViewList)">
			<div
				*ngFor="
					let project of projectsViewList
						| search: 'name' : projectSearchText
						| slice: 0 : projectsLimit;
					let i = index
				"
				class="padding-0-5 p-b-0"
				fxLayout="row"
			>
				<mat-card
					(drop)="drop($event, project.id)"
					[dragOverClass]="'dropHover'"
					class="full-width"
					[ngClass]="{ 'panel-selected mat-elevation-z4': project.id == addCarriersToProject?.id }"
					dragHintClass="no-border"
					droppable
				>
					<mat-card-content
						(click)="navigateToProjectDetails(project.id)"
						class="primary-text cursor-pointer"
					>
						<div fxLayout="row" fxLayoutGap="1rem">
							<ng-container
								*ngTemplateOutlet="projectNameTemplate; context: { $implicit: project }"
							></ng-container>
							<div fxFlex fxLayoutAlign="end center">
								Customer: {{ project?.customerDTO ? (project.customerDTO?.name | titleCase) : 'N/A' }}
							</div>
						</div>

						<div class="m-t-1" fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex fxLayoutAlign="start center">
								volume: {{ project?.monthlyVolumeDisplay ? project.monthlyVolumeDisplay : 'N/A' }}
							</div>
							<div fxFlex fxLayoutAlign="end center">
								Carriers:
								<span
									[matBadge]="project.carrierCount"
									[ngClass]="{ 'custom-badge-w-auto': project.carrierCount >= 100 }"
									class="custom-badge m-r-1-4 pl-2"
									matBadgeOverlap="false"
								></span>
							</div>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</div>

		<div
			*ngIf="!isLoadingProjectsList && projectsNextPage && !showOnlySelectedCarriersProject"
			class="m-t-1"
			fxLayout="row"
			fxLayoutAlign="center center"
		>
			<button (click)="viewMoreProjects()" color="primary" mat-raised-button>Load More</button>
		</div>
	</div>
</div>
<ng-template #projectNameTemplate let-project>
	<div
		*ngIf="
			IS_NOT_EMPTY(project.lanePath) || IS_NOT_EMPTY(project.lane);
			else withoutLanePathTemplate
		"
	>
		<div
			(click)="
				$event.stopImmediatePropagation();
				project.isProjectNameDisplayed = !project.isProjectNameDisplayed
			"
			fxFlex
			fxLayoutAlign="start center"
		>
			<span *ngIf="project.isProjectNameDisplayed">
				{{ project.name || project.projectName }}
			</span>
			<span *ngIf="!project.isProjectNameDisplayed">
				{{ project.lanePath || project.lane }}
			</span>
			<mat-icon [inline]="true" class="primary-text w-inherit" matSuffix> flip_to_back </mat-icon>
		</div>
	</div>
	<ng-template #withoutLanePathTemplate>
		{{ project.name || project.projectName }}
	</ng-template>
</ng-template>
